//Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//3rd party imports
import { plainToInstance } from 'class-transformer';

//RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

//Service imports
import { RPCacheRegistrationService } from '../../../_services/shared-services/rp-cache-registration-service';

//Model imports
import { BaseResidentParameterDto } from '../../../_models/base-resident-parameter-dto';
import { CashInvestmentResultDto } from './../../_models/cash-investment-result-dto';
import { ExpenseBreakdownResultDto } from './../../_models/expense-breakdown-result-dto';
import { AccountStandingResultDto } from './../../_models/account-standing-result-dto';
import { HomeOwnersWithOpenViolationsSummaryResultDto } from './../../_models/home-owners-with-open-violations-summary-result-dto';

//Service imports
import { EnvironmentConfigService } from '../../../_services/environment-config.service';

//Constants
import { CacheDuration } from '../../../_constants/cache-duration';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(
    private httpClient: HttpClient,
    private cacheRegistrationService: RPCacheRegistrationService,
    private envConfig: EnvironmentConfigService
  ) {}

  getCashInvestment(
    data: BaseResidentParameterDto
  ): Observable<CashInvestmentResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/dashboard/' +
      'cashinvestment' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<CashInvestmentResultDto[]>(url, options)
      .pipe(
        map((responseData: CashInvestmentResultDto[]) =>
          plainToInstance(CashInvestmentResultDto, responseData)
        )
      );
  }

  getAccountStatus(
    data: BaseResidentParameterDto
  ): Observable<AccountStandingResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/dashboard/' +
      'accountsstanding' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<AccountStandingResultDto[]>(url, options)
      .pipe(
        map((responseData: AccountStandingResultDto[]) =>
          plainToInstance(AccountStandingResultDto, responseData)
        )
      );
  }

  getExpenseBreakdown(
    data: BaseResidentParameterDto
  ): Observable<ExpenseBreakdownResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/dashboard/' +
      'expenses' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<ExpenseBreakdownResultDto[]>(url, options)
      .pipe(
        map((responseData: ExpenseBreakdownResultDto[]) =>
          plainToInstance(ExpenseBreakdownResultDto, responseData)
        )
      );
  }

  getHomeOwnersWithViolation(
    data: BaseResidentParameterDto
  ): Observable<HomeOwnersWithOpenViolationsSummaryResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'community/dashboard/' +
      'openviolations' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<HomeOwnersWithOpenViolationsSummaryResultDto[]>(url, options)
      .pipe(
        map((responseData: HomeOwnersWithOpenViolationsSummaryResultDto[]) =>
          plainToInstance(
            HomeOwnersWithOpenViolationsSummaryResultDto,
            responseData
          )
        )
      );
  }
}
